import styles from './index.module.css'
import { List, ListItem } from '@appkit4/react-components/list'
import classnames from 'classnames'

export const View = ({ onItemClick, handleKeyDown, selectedValue, className, isDark, itemKey, ...props }) => {
    const darkClassName = isDark ? styles.dark : ''

    const renderItem = (item, index) => {
        const key = item[itemKey]
        const isSelected = selectedValue === key
        const selectedClass = isSelected ? styles.selected : ''
        // NOTE: Listコンポーネントにulが存在しないため、ListItem(liタグ)をulでラップ
        return (
            <ul className={styles.list}>
                <ListItem
                    className={classnames(styles.list_item, selectedClass)}
                    key={key}
                    onClick={() => !isSelected && onItemClick && onItemClick(key, index)}
                    onKeyDown={(e) => !isSelected && handleKeyDown(key, index, e)}
                >
                    {item.content}
                </ListItem>
            </ul>
        )
    }

    return (
        <List
            className={classnames(styles.default, darkClassName, className)}
            renderItem={renderItem}
            itemKey={itemKey}
            {...props}
        />
    )
}
